import { createAction, props } from '@ngrx/store';
import { IAdditionalData, IField } from '@shared/model/basic-data';

export enum AdditionalDataActionTypes {
  GET_ADDITIONAL_DATA = '[Basic Data] Get Additional Data',
  GET_ADDITIONAL_DATA_SUCCESS = '[Basic Data] Get Additional Data Success',
  GET_ADDITIONAL_DATA_FAILURE = '[Basic Data] Get Additional Data Failure',

  UPDATE_ADDITIONAL_DATA = '[Basic Data] Update Additional Data',
  UPDATE_ADDITIONAL_DATA_SUCCESS = '[Basic Data] Update Additional Data Success',
  UPDATE_ADDITIONAL_DATA_FAILURE = '[Basic Data] Update Additional Data Failure',
}

export const getAdditionalData = createAction(AdditionalDataActionTypes.GET_ADDITIONAL_DATA, props<{ id: number }>());

export const getAdditionalDataSuccess = createAction(
  AdditionalDataActionTypes.GET_ADDITIONAL_DATA_SUCCESS,
  props<{ additionalData: IAdditionalData }>(),
);

export const getAdditionalDataFailure = createAction(AdditionalDataActionTypes.GET_ADDITIONAL_DATA_FAILURE);

export const updateAdditionalData = createAction(
  AdditionalDataActionTypes.UPDATE_ADDITIONAL_DATA,
  props<{ id: number; data: IField }>(),
);

export const updateAdditionalDataSuccess = createAction(
  AdditionalDataActionTypes.UPDATE_ADDITIONAL_DATA_SUCCESS,
  props<{ data: IField }>(),
);

export const updateAdditionalDataFailure = createAction(AdditionalDataActionTypes.UPDATE_ADDITIONAL_DATA_FAILURE);
